import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { meQueryOptions } from "@/api/queries/session";
import { safeRedirect } from "@/auth/redirect";
import { LoginPage } from "@/features/auth/login-page";

export const Route = createFileRoute("/login")({
  validateSearch: z.object({ redirect: z.string().optional().catch(undefined) }),
  beforeLoad: async ({ context, search }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions());
    if (me) throw redirect({ href: safeRedirect(search.redirect) });
  },
  head: () => ({ meta: [{ title: "Sign in · Rogue AI" }] }),
  component: LoginPage,
});
